import React, { useEffect, useRef } from 'react';
// Constants
import {
  CompanyName,
  CONTENT_FORM_URL,
  KeywordsPages,
  QUESTIONAIRE_URL,
  SUB_APPLICATION_FORM_URL,
} from '../../utils/Constants';
// Data
import {
  contactPageAdditionalMeta,
  contactPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import ContactPageMainContainer from '../../components/contact/ContactPageMainContainer';
// Videos
import MainImage1 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-ass-and-horns.jpg';

function ContactPage() {
  const videoRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && videoRef.current) {
          videoRef.current.play().catch((e) => {
            // Handle auto-play restrictions (e.g., user hasn't interacted yet)
            console.log('Autoplay failed:', e);
          });
        }
      },
      { threshold: 0.5 } // Adjust as needed
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) observer.unobserve(videoRef.current);
    };
  }, []);
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Contact'
        desc={`Submit your tribute and request an audience with ${CompanyName}, King Liyah Minx. Serious inquiries only. Approach with respect and devotion.`}
        keywords={KeywordsPages}
        additionalMeta={contactPageAdditionalMeta}
        structuredData={contactPageStructuredData}
      />

      {/* Page */}
      <div className='grid relative min-h-screen font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />

          <header className='pt-24 px-6'>
            <h1 className='text-center font-titleFont text-5xl lg:text-7xl text-colour7 tracking-widest'>
              Contact King Liyah Minx
            </h1>

            <div className='mx-auto uppercase tracking-wider text-xl grid justify-center mt-2 px-4 text-center'>
              <h2>Book A Session or Submit Questions</h2>
            </div>

            <div className='mx-auto grid justify-center px-4 text-center max-w-xl'>
              <p className='pt-4 text-lg'>
                I am King Liyah Minx — BBW ebony superior, sadistic seductress,
                and financial carnage aficionado. Serious inquiries only.
                Tribute is expected for booking and questions.
              </p>

              <section className='grid mt-8'>
                {/* Image */}
                <div className='my-auto'>
                  <img
                    src={MainImage1}
                    alt={`${CompanyName} with neon diamond logo`}
                    className='mx-auto object-cover md:max-h-[60vh] rounded neon_shadow'
                    loading='lazy'
                  />
                </div>
              </section>

              <p className='pt-6'>
                To apply for ownership or priority sub status, please fill out
                the questionnaire below. It is required before booking IRL or
                online sessions.
              </p>

              <div className='grid gap-y-2 h-fit'>
                <a
                  href={SUB_APPLICATION_FORM_URL}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='inline-block mt-6 px-8 py-3 bg-colour7 text-white font-semibold rounded hover:bg-red-900 transition-colors'
                >
                  Sub Application Form
                </a>
                <a
                  href={QUESTIONAIRE_URL}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='inline-block mt-6 px-8 py-3 bg-colour7 text-white font-semibold rounded hover:bg-red-900 transition-colors'
                >
                  Book a session Form
                </a>
                <a
                  href={CONTENT_FORM_URL}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='inline-block mt-6 px-8 py-3 bg-colour7 text-white font-semibold rounded hover:bg-red-900 transition-colors'
                >
                  Content Partner Form
                </a>
              </div>

              <p className='pt-6 text-sm'>
                <strong>Note:</strong> I only respond to serious, respectful
                messages via Email and LoyalFans. Other platforms will not be
                checked.
              </p>
              <p className='pt-6 text-sm'>
                <strong>Note:</strong> Please note that any submission without
                tribute will be ignored and application becomes void and trashed
              </p>
            </div>
          </header>

          {/* Main page content */}
          <ContactPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default ContactPage;
